import { render, staticRenderFns } from "./Inquiries1column.vue?vue&type=template&id=9bc47160&scoped=true&"
import script from "./Inquiries1column.vue?vue&type=script&lang=js&"
export * from "./Inquiries1column.vue?vue&type=script&lang=js&"
import style0 from "./Inquiries1column.vue?vue&type=style&index=0&id=9bc47160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc47160",
  null
  
)

export default component.exports